export const GPT61_SOL_MODEL = "gpt-6.1-sol";
export const GPT6_LUNA_MODEL = "gpt-6-luna";

// Keep saved preferences usable without offering retired models for new calls.
export const migrateLegacyOpenAIModel = (model) => {
  if (typeof model !== "string" || !/^gpt-5(?:[.-]|$)/.test(model)) {
    return model;
  }
  return /-(?:mini|nano|luna)(?:-|$)/.test(model)
    ? GPT6_LUNA_MODEL
    : GPT61_SOL_MODEL;
};

export const requiresOpenAIReasoning = (model) =>
  model === "gpt-6-astra" || model === GPT61_SOL_MODEL;
